import useScrollListener from "./useScrollListener";
/**
 * This is a simple component wrapper for the `useScrollListener` hook.
 */
export default function ScrollListener(props) {
    useScrollListener(props);
    return null;
}
//# sourceMappingURL=ScrollListener.js.map